import React from 'react';

const StepIndicator = ({ currentStep, totalSteps }) => {
  return (
    <div className="flex items-center justify-center mb-4">
      {Array.from({ length: totalSteps }, (_, index) => {
        const stepNumber = index + 1;
        const isActive = stepNumber === currentStep;
        const isCompleted = stepNumber < currentStep;
        
        return (
          <React.Fragment key={stepNumber}>
            <div className="flex flex-col items-center">
              <div
                className={`
                  w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium
                  ${isActive 
                    ? 'bg-primary-600 text-white' 
                    : isCompleted 
                      ? 'bg-green-500 text-white' 
                      : 'bg-gray-200 text-gray-600'
                  }
                `}
              >
                {isCompleted ? '✓' : stepNumber}
              </div>
              <div className="mt-1">
                <p className={`text-xs font-medium text-center ${
                  isActive ? 'text-primary-600' : 'text-gray-500'
                }`}>
                  {stepNumber === 1 && 'Dados'}
                  {stepNumber === 2 && 'Profissional'}
                  {stepNumber === 3 && 'Resumo'}
                </p>
              </div>
            </div>
            {stepNumber < totalSteps && (
              <div className={`w-8 h-1 mx-2 ${
                stepNumber < currentStep ? 'bg-green-500' : 'bg-gray-200'
              }`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepIndicator;
